import React from 'react';
import { NoAccountIcon } from '../../../components';
import { LinkTokenErrorScreen } from './LinkTokenErrorScreen';

/**
 * 招待リンクは有効だが、事業所側で第三者提供同意（ADR-025 / third_party_consents）が
 * まだ記録保存されていない場合に表示するフルページ画面。
 *
 * link/verify のレスポンス `has_third_party_consent === false` の時にこの画面へ流入する。
 * 事業所側で同意取得が完了したら、招待リンクを再度開き直してもらう運用（初版）。
 *
 * 詳細: docs/pre-design/communication-secret-consent/design.md §4.1 / §8.2
 */
export const NotYetAvailable: React.FC = () => {
  return (
    <LinkTokenErrorScreen
      icon={<NoAccountIcon />}
      title="まだご利用いただけません"
      description={
        'デイサービスでの同意手続きが\n完了次第、ご利用いただけます。\n恐れ入りますが、しばらくお待ちください。'
      }
    />
  );
};

export default NotYetAvailable;
